import useModal from "../base/modal/useModal";
import MxAlertTemplate, {
  MxAlertProps
} from "../components/l1/alert/MxAlertTemplate";

type MxAlertPropsOmit = Omit<MxAlertProps, "type" | "color">;
function useAlert() {
  const { modal } = useModal();
  const options = {
    size: {
      xs: {
        width: "90%",
        height: "auto"
      },
      sm: {
        width: "300px",
        height: "auto",
        maxHeight: "300px"
      },
      md: {
        width: "450px",
        height: "auto",
        maxHeight: "300px"
      },
      lg: {
        width: "450px",
        height: "auto",
        maxHeight: "300px"
      },
      xl: {
        width: "450px",
        height: "auto",
        maxHeight: "300px"
      }
    },
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    disableCloseButton: true,
    disableHeader: true
  };

  const alert = (p: MxAlertProps) => {
    return modal({
      template: <MxAlertTemplate {...p} />,
      options: options
    });
  };

  const warningAlert = (p: MxAlertPropsOmit) => {
    const props: MxAlertProps = {
      ...p,
      type: "warning",
      color: "warning.main"
    };
    return modal({
      template: <MxAlertTemplate {...props} />,
      options: options
    });
  };

  const errorAlert = (p: MxAlertPropsOmit) => {
    const props: MxAlertProps = {
      ...p,
      type: "error",
      color: "error.main"
    };
    return modal({
      template: <MxAlertTemplate {...props} />,
      options: options
    });
  };

  const successAlert = (p: MxAlertPropsOmit) => {
    const props: MxAlertProps = {
      ...p,
      type: "success",
      color: "success.main"
    };
    return modal({
      template: <MxAlertTemplate {...props} />,
      options: options
    });
  };

  const infoAlert = (p: MxAlertPropsOmit) => {
    const props: MxAlertProps = {
      ...p,
      type: "info",
      color: "info.main"
    };
    return modal({
      template: <MxAlertTemplate {...props} />,
      options: options
    });
  };

  const loadingAlert = (p: MxAlertPropsOmit) => {
    const props: MxAlertProps = {
      ...p,
      type: "loading",
      color: "primary.main",
      hideButtons: true
    };
    const loadingOptions = {
      ...options,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
      disableCloseButton: true
    };
    return modal({
      template: <MxAlertTemplate {...props} />,
      options: loadingOptions
    });
  };

  return {
    alert,
    warningAlert,
    errorAlert,
    successAlert,
    infoAlert,
    loadingAlert
  };
}
export default useAlert;
